import { createContext, useContext, useState } from 'react';

const LiveAccountContext = createContext();

const initialState = {
  isOpenFormUpsert: false,
  selectedAccount: {},
  errorMessage: null,
  errorProps: {},
  errorFields: {},
};

const initialFilterState = {
  page: 1,
  limit: 10,
  platform: [],
  brand: [],
  accountType: [],
  sort: { field: 'id', order: 'desc' },
  search: null,
};

const LiveAccountProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return (
    <LiveAccountContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>
      {children}
    </LiveAccountContext.Provider>
  );
};

export const useLiveAccountState = () => {
  return useContext(LiveAccountContext);
};

export default LiveAccountProvider;
